import { type FC } from 'react'
import './_userCard.scss'

// import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import * as Icons from 'assets/svg/sprite'
import { addToast } from 'components/Toast/Toast'
import { useModalContext } from 'context/modalContext'
import { blockUser, restrictUser } from 'services/endpoints/report'

import AvatarHolder from '../AvatarHolder/AvatarHolder'
import ConfirmModal from '../Modal/Confirm/ConfirmModal'

const UserCardRestricted: FC<{
    user: any
    successFn?: () => void
    clearModal?: boolean
}> = ({ user, clearModal = true }) => {
    // const { t } = useTranslation()
    const queryClient = useQueryClient()
    const modalData = useModalContext()

    const restrictMutation = useMutation(
        async () => await restrictUser(user.id),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['getRestrictedUsers'])
                if (clearModal) {
                    modalData.clearModal()
                }
            },
            onError: () => {
                addToast('error', 'Something went wrong')
            }
        }
    )

    return (
        <div className='userCard userCard--blocked'>
            <div className='userCard__avatar'>
                <AvatarHolder img={user.avatar.url} size='60' />
            </div>
            <div className='userCard__info'>
                <p className='userCard__info__name'>{user.name}</p>
                <p className='userCard__info__username'>{`@${user.username}`}</p>
            </div>
            {/* <Button
                text={t('unblock')}
                color='transparent'
                type='transparent--black1px'
                font='mont-14-normal'
                height='3'
                width='fit'
                padding='2'
                clickFn={() => blockMutation.mutate()}
            /> */}
            <div
                className='actionCard__fans__icons--twoPeople'
                onClick={() => {
                    modalData.addModal(
                        'Unrestrict User',
                        <ConfirmModal
                            body='Are you sure you want to unrestrict user?'
                            confirmFn={() => {
                                restrictMutation.mutate()
                            }}
                        />
                    )
                }}
            >
                <Icons.IconUnrestrictUser />
            </div>
        </div>
    )
}

export default UserCardRestricted
